import { useDispatch } from "react-redux";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { fetchVideo } from "../../features/video/videoSlice";
import {
  updatesLikeCount,
  updatesUnlikeCount,
} from "../../features/videos/videosSlice";

export default function LikeUnlike({ video }) {
  const dispatch = useDispatch();
  const updateLikeHandler = (id) => {
    const payload = {
      ...video,
      likes: video.likes + 1,
    };
    const callback = () => {
      dispatch(fetchVideo(video?.id));
    };
    dispatch(updatesLikeCount({ id: id, data: { ...payload }, cb: callback }));
  };

  const updateUnLikeHandler = (id) => {
    const payload = {
      ...video,
      unlikes: video.unlikes + 1,
    };
    const callback = () => {
      dispatch(fetchVideo(video?.id));
    };
    dispatch(
      updatesUnlikeCount({ id: id, data: { ...payload }, cb: callback })
    );
  };

  return (
    <div className="flex gap-10 w-48">
      <div className="flex gap-1">
        <div
          className="shrink-0"
          onClick={(e) => {
            e.stopPropagation();
            updateLikeHandler(video?.id);
          }}
        >
          <img className="w-5 block" src={likeImage} alt="Like" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {video?.likes || 0}
        </div>
      </div>
      <div className="flex gap-1">
        <div
          className="shrink-0"
          onClick={(e) => {
            e.stopPropagation();
            updateUnLikeHandler(video?.id);
          }}
        >
          <img className="w-5 block" src={unlikeImage} alt="Unlike" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {video?.unlikes || 0}
        </div>
      </div>
    </div>
  );
}
